import styles from "./service_brand.module.scss"
import parse from "html-react-parser"

interface Props {
  description?: string
  image: string
  title: string
}

export default function ServiceBrand({ description, image, title }: Props) {
  return (
    <>
      <img title={title} alt={title} className={styles["service-brand"]} width="120" height="120" src={image} />
      <h1 className={styles["brand-title"]}>{parse(title)}</h1>
      {description && <p className={styles["brand-description"]}>{description}</p>}
    </>
  )
}
